const candlelightData = [
  {
    title: "Candlelight Dinner",
    image: "/Assets/all_candlelight_dinnner.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Indoor Candlelight Dinner",
    image: "/Assets/Indoor Pool.webp",
    price: 3999,
    rating: 3,
  },
  {
    title: "Luxury Candlelight Dinner",
    image: "/Assets/Luxury Candle light Dinner.webp",
    price: 5999,
    rating: 4,
  },
  {
    title: "Cabana Candlelight Dinner",
    image: "/Assets/Cabana Candle light Dinner.webp",
    price: 7999,
    rating: 3,
  },
  {
    title: "Poolside Dinners",
    image: "/Assets/poolside_dinners.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Indoor Pool Side Dinner",
    image: "/Assets/Indoor Pool Side_.jpg",
    price: 3999,
    rating: 4,
  },
  {
    title: "Open Air Pool Side Cabana Candlelight Dinner",
    image: "/Assets/Open Air Cabana Candlelight Dinner .webp",
    price: 5999,
    rating: 4,
  },
  {
    title: "Poolside Bliss Candlelight Dinner",
    image: "/Assets/Poolside Bliss Candlelight Dinner.jpg",
    price: 7999,
    rating: 4,
  },
  {
    title: "Restaurant Dinners",
    image: "/Assets/restaurant_dinners.webp",
    price: 1999,
    rating: 4,
  },
  {
    title: "Buffet Dinners",
    image: "/Assets/Buffet Dinner.jpg",
    price: 3999,
    rating: 4,
  },
  {
    title: "Family Style Dinner",
    image: "/Assets/Family Style Dinner.webp",
    price: 5999,
    rating: 4,
  },
  {
    title: "Roof Top Dinner",
    image: "/Assets/Roof Top.jpg",
    price: 7999,
    rating: 4,
  }
];

export default candlelightData;
